import { contains } from 'modules/utils';
import { DatePicker } from './DatePicker';
import { Header } from './Header';
import { YearPicker } from './YearPicker';
import { useCalendar } from '../Context';
import { Container, Column } from '../styled';
export function Calendar() {
    const { onFocus, onBlur, onKeyDown, yearPickerVisible } = useCalendar();
    const handleBlur = (event) => {
        if (onBlur && !contains(event.currentTarget, event.relatedTarget)) {
            onBlur(event);
        }
    };
    return (<Container tabIndex={0} onFocus={onFocus} onBlur={handleBlur} onKeyDown={onKeyDown}>
      <Column>
        <Header />
        {yearPickerVisible ? <YearPicker /> : <DatePicker />}
      </Column>
    </Container>);
}
